import { lifiLogoUrl } from '../icons/lifi.js';
export const defaultCoinbaseConfig = {
    appName: 'LI.FI',
    appLogoUrl: lifiLogoUrl,
};
//# sourceMappingURL=coinbase.js.map